<template>
	<!-- 关于我们 -->
	<div class="content1">
		<header1 :pathname="pathname" @showMobile="showMobile"></header1>
		<nemunav :list="navList" navBgImg="about" :menutitle="menutitle" :current="navIndex" @tapMenu="tapMenu" :navIndex="selectIndex"></nemunav>
		<about1 v-if="selectIndex==0"></about1>  
		<about2 v-if="selectIndex==1"></about2>
		<about3 v-if="selectIndex==2" :list1="list1" :list2="list2" :list3="list3" :list4="list4"
		@previewImage="previewImage"></about3>
		<about4 v-if="selectIndex==3"></about4>
		<footer1></footer1>
		
		<mobilemenu v-if="isShowMobile" @hiddenMobile="hiddenMobile"></mobilemenu>
		
		 
	</div>
</template>  

<script>
	import {
	  contentlist
	} from '@/api/home.js'
	import mobilemenu from "@/components/mobile-menu.vue";
	import header1 from "@/components/header.vue";
	import nemunav from "@/components/nemunav.vue";
	import about1 from "@/components/about/index1.vue";
	import about2 from "@/components/about/index2.vue";
	import about3 from "@/components/about/index3.vue";
	import about4 from "@/components/about/index4.vue";
	import footer1 from "@/components/footer.vue";
	export default {
		components: {
			mobilemenu,
			header1,
			footer1,
			nemunav,
			about1,
			about2,
			about3,
			about4,
		},
		data() {
			return {
				pathname: "about",
				menutitle:"关于中概",
				navList:["公司简介", "组织架构", "资质荣誉", "企业文化"],
				isShowMobile:false,
				selectIndex:0,
				navIndex :0,
				list1:[],
				list2:[],
				list3:[],
				list4:[],
				dialogVisible: false,
				dialogImageUrl: ''
				
			}
		},
		created() {
			console.log(this.$route.query, "0")
			// this.navIndex = this.$route.query
			this.selectIndex = this.$route.query.index?this.$route.query.index:0
			this.getproductlist1()
			this.getproductlist2()
			this.getproductlist3()
			this.getproductlist4()
		},
		methods: {
			getproductlist1() {
			  contentlist({
			    pageNum: 1,
				pageSize:100,
				companyId:1,
				categoryId:430
			  }).then(res => {
			    if (res.data.code == 200) {
			      this.list1 = res.data.rows
			    }
			  })
			},
			getproductlist2() {
			  contentlist({
			    pageNum: 1,
				pageSize:100,
				companyId:1, 
				categoryId:431
			  }).then(res => {
			    if (res.data.code == 200) {
			      this.list2 = res.data.rows
			    }
			  })
			},
			getproductlist2() {
			  contentlist({
			    pageNum: 1,
				pageSize:100,
				companyId:1,
				categoryId:431
			  }).then(res => {
			    if (res.data.code == 200) {
			      this.list2 = res.data.rows
			    }
			  })
			},
			getproductlist3() {
			  contentlist({
			    pageNum: 1,
				pageSize:100,
				companyId:1,
				categoryId:432
			  }).then(res => {
			    if (res.data.code == 200) {
			      this.list3 = res.data.rows
			    }
			  })
			},
			getproductlist4() {
			  contentlist({
			    pageNum: 1,
				pageSize:100,
				companyId:1,
				categoryId:445
			  }).then(res => {
			    if (res.data.code == 200) {
			      this.list4 = res.data.rows
			    }
			  })
			},
			previewImage(url) {
				console.log(url, "ppppppppppp")
			    this.dialogImageUrl = url;
			    this.dialogVisible = true;
			},
			
			tapMenu(e) {
				this.selectIndex = e
			},
			showMobile() {
				console.log("ooooo")
				this.isShowMobile = true
			},
			hiddenMobile() {
				this.isShowMobile = false
			}

		}
	}
</script>

<style lang="scss">
	@media screen and (min-width: 1200px) {
		.content1 {
			padding-top: 100px;
		}
	
	}
	@media screen and (max-width: 1200px) {
		.content1 {
			padding-top: 80px;
		}
	
	}
	@media screen and (max-width: 880px) {
		.content1 {
			padding-top: 50px; 
		}
	
	}
</style>
